
import config from "config";
import gsap from "gsap";
import AssetsManager from "js/components/AssetsManager";
import GameManager from "js/components/GameManager";
import LocaleManager from "js/components/LocaleManager";
import Scroll from "lib/scroll";
import { Container, Graphics, Sprite, TextStyle, Text, DEG_TO_RAD, NineSlicePlane, SpriteMaskFilter } from "pixi.js";
import tools from "tools";
import Btn2 from "./btn2";
import ChallengerBtn from "./challengerBtn";
const WIDTH = config.view.x;
const HEIGHT = config.view.y;

export default class Leaderboard extends Container {


    constructor(domElement) {

        super();

        tools.autobind(this);

        this._domElement = domElement;

        const background = new Graphics();
        background.beginFill(0x4c6e89, .9);
        background.drawRect(-.5, -.5, 1, 1);
        background.endFill();
        background.scale.set(WIDTH * 4, HEIGHT);
        this.addChild(background);

        this._init();
        this._initEvents();

    }



    _init() {


        this.coupe = new Sprite(AssetsManager.texturesPixi.coupe);
        this.coupe.anchor.set(.5);
        this.coupe.y = -310;
        this.addChild(this.coupe);


        const currentTextStyle = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 20,
            align: "left",
            fill: 0xffffff
        });

        this.titleText = new Text(LocaleManager.words.currentscore, currentTextStyle);
        this.titleText.anchor.x = .5;
        // this.titleText.anchor.y = .5;
        this.titleText.x = 0;
        this.titleText.y = -535;
        this.addChild(this.titleText);


        const scoreStyle = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 30,
            // fill: ['#ffffff', '#72bbf1'],
            fill: ['#ffffff', '#d9f7fc'],
            stroke: '#000000',
            strokeThickness: 3
        });


        this.scoreText = new Text(0, scoreStyle);
        this.scoreText.anchor.x = .5;
        this.scoreText.x = 0//this.titleText.x + this.titleText.width + 20;
        this.scoreText.y = this.titleText.y + this.titleText.height - 9;
        // this.scoreText.anchor.y = .5;
        this.addChild(this.scoreText);


        this.rect = new Graphics();
        this.rect.beginFill(0xb07d1a, .5);
        this.rect.drawRoundedRect(-105, -45, 210, 90, 10);
        this.rect.endFill();
        this.rect.y = -432
        this.addChild(this.rect);

        this.bestScoreLabel = new Text(LocaleManager.words.mybestcore, currentTextStyle);
        this.bestScoreLabel.anchor.x = .5;
        this.bestScoreLabel.x = 0;
        this.bestScoreLabel.y = -470;


        const bestScoreStyle = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 44,
            fill: ['#ffffff', '#d9f7fc'],
            stroke: '#000000',
            strokeThickness: 3
        });



        this.bestScoreText = new Text(300, bestScoreStyle);
        this.bestScoreText.x = 0;//this.bestScoreLabel.x + this.bestScoreLabel.width + 20;
        this.bestScoreText.y = this.bestScoreLabel.y + this.bestScoreLabel.height - 5;
        this.bestScoreText.anchor.x = .5;




        this.container = new Container();
        this.container.x = WIDTH / 2;

        this.scroll = new Scroll(this._domElement);
        this.scroll.axe = "y";
        this.scroll.viewY = 600;
        this.scroll.viewX = WIDTH;
        this.scroll.y = -300;
        this.scroll.x = -WIDTH / 2;
        this.scroll.visible = false;
        this.scroll.add(this.container);
        this.addChild(this.scroll);


        let gradientTop = new Sprite(AssetsManager.texturesPixi.gradient);
        gradientTop.tint = 0x4c6e89;
        gradientTop.anchor.set(.5, 1);
        gradientTop.rotation = Math.PI;
        gradientTop.y = -380;
        gradientTop.scale.y = .5;
        gradientTop.width = WIDTH;
        this.addChild(gradientTop);


        let gradientBottom = new Sprite(AssetsManager.texturesPixi.gradient);
        gradientBottom.tint = 0x4c6e89;
        gradientBottom.anchor.set(.5, 0);
        gradientBottom.y = 230;
        gradientBottom.scale.y = .5;
        gradientBottom.width = WIDTH;
        this.addChild(gradientBottom);


        this.addChild(this.bestScoreLabel);
        this.addChild(this.bestScoreText);


        this.inviteBtn = new Btn2(LocaleManager.words.playFriends, 25, 0xffffff, 0x3C2FA1, AssetsManager.texturesPixi.friendsPicto, { width: 350, height: 100 }, .8);
        this.inviteBtn.click = this._invite;
        this.inviteBtn.x = -145;
        this.inviteBtn.y = 370;
        this.inviteBtn.animate();
        this.inviteBtn.visible = false;
        this.addChild(this.inviteBtn);


        this.playBtn = new Btn2(LocaleManager.words.leaderPlay, 40, 0xffffff, 0x72f17e, null, { width: 300, height: 100 }, .8);
        this.playBtn.click = this.closePopin;
        this.playBtn.x = 145;
        this.playBtn.y = 340;
        this.playBtn.visible = false;
        this.addChild(this.playBtn);



        const bannerStyle = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 38,
            fill: ['#ffffff', '#d9f7fc'],
            stroke: '#000000',
            strokeThickness: 3
        });


        this.banner = new NineSlicePlane(AssetsManager.texturesPixi.banner, 250, 250, 300, 4);
        this.banner.x = -350;
        this.banner.y = -396;
        this.banner.tint = 0xe73266;
        this.banner.width = 1400;
        this.banner.scale.set(.5, .4);
        this.addChild(this.banner);

        this.bannerText = new Text(LocaleManager.words.leaderboard, bannerStyle);
        this.bannerText.anchor.set(.5);
        this.bannerText.y = -350;
        this.addChild(this.bannerText);

        this.visible = false;
        this.scale.set(.02);

    }






    _initEvents() {

        this.interactive = true;

    }


    _onDown() {

        if (this._isDown) {
            return;
        }

        this._isDown = true;
        this.tween = gsap.to(this.close.scale, { duration: .2, x: .43, y: .43 });
    }



    _onUp() {

        if (!this._isDown) {
            return;
        }

        this._isDown = false;
        this.tween && this.tween.kill();
        this.tween = gsap.to(this.close.scale, { duration: .2, x: .5, y: .5 });

        this.hide();

    }


    _onOut() {
        this._isDown = false;
        this.tween && this.tween.kill();
        this.tween = gsap.to(this.close.scale, { duration: .2, x: .5, y: .5 });
    }




    _invite() {


        GameManager.H5SDK.getFriendsModule().inviteFriends(AssetsManager.b64Picture, LocaleManager.words.myscore + this.score + "!" + LocaleManager.words.canyoudobetter).then(
            () => {
                console.log("retour de la popin");
                this.closePopin();
                config.inviteFriend = true;
            }
        );


    }



    get size() {
        return { width: WIDTH, height: HEIGHT }
    }




    closePopin() {

        if (this._isCloseClicked) {
            return;
        }

        this.playBtn.visible = false;
        
        document.getElementById("banner-landscape-1").style.display = "none";
        document.getElementById("banner-landscape-2").style.display = "none";
       // GameManager.H5SDK.getPlatform().getAdsModule().hideBanner();
       // GameManager.H5SDK.getPlatform().getModule("AdReloadModule").clean({name:"Banner", id:6});
        GameManager.H5SDK.getAdsModule().requestInterstitialAd().then(() => {
            this._isCloseClicked = true;

            this.hide();
    
            console.log(GameManager)
            GameManager.restart();
        });

        

    }







    show() {
       
        document.getElementById("banner-landscape-1").style.display = "block";
        document.getElementById("banner-landscape-2").style.display = "block";
        GameManager.H5SDK.getPlatform().getAdsModule().requestBannerAd();
        if (!GameManager.H5SDK.getPlatform().isFacebook()) {
            this.playBtn.x = 0;
        }


        this.height = window.innerHeight;
        let sacle = this.scale.y;
        this.height = 0;
        this.scroll.visible = true;
        this.visible = true;
        gsap.to(this.scale, {
            delay: .3, duration: .5, x: sacle, y: sacle, ease: "power4.out", onComplete: () => {
            }
        });

        this.inviteBtn.visible = false;
        this.playBtn.visible = false;

        this.showLeaderboardInfos();

        let tmp = this.score;
        this.score = 0;
        gsap.to(this, { duration: 1, score: tmp });

    }


    hide() {



        gsap.to(this.scale, {
            duration: .4, x: .02, y: .02, ease: "power2.in", onComplete: () => {
                this.visible = false;
                this.scroll && this.scroll.clear();
                this.scrollAccess = false;
                this.scroll.visible = false;

                while (this.container.children.length > 0) {
                    let child = this.container.getChildAt(0);
                    child.destroy();
                }

                this._isCloseClicked = false;

            }
        });

    }


    showLeaderboardInfos() {

        console.log("showLeaderboardInfos")

        config.playersReady = false;

        while (this.container.children.length > 0) {
            let child = this.container.getChildAt(0);
            child.destroy();
        }


        this.scroll.add(this.container);


        let pos = 0;
        let rankingArray = [];
        let rankingArrayTop = [];
        let idTop = 0;
        let rankingArrayBottom = [];
        let idBottom = 0;
        let _you = null;

        if (config.currentleaderboard) {

            for (let i = 0; i < config.currentleaderboard.length; i++) {
                if (config.currentleaderboard[i].name == "You") {
                    _you = config.currentleaderboard[i];
                    _you.score = GameManager.BEST_SCORE;
                    _you.ID = i;
                    config.currentleaderboard.splice(i, 1);
                    break;
                }
            }

            console.log("you:", _you);

            let topScoreFriends = 0;

            for (let j = 0; j < config.friends.length; j++) {

                if (_you && config.friends[j].score > _you.score || !config.friends[j].isRealScore) {
                    rankingArrayTop.push(config.friends[j]);
                    topScoreFriends = config.friends[j].score > topScoreFriends ? config.friends[j].score : topScoreFriends;

                    if (!config.friends[j].isRealScore) {
                        config.friends[j].invite = true;
                        // config.friends[j].id = Math.random() + "";  // just for test
                    }


                } else {
                    rankingArrayBottom.push(config.friends[j]);
                }

            }

            let element;
            let idTop = rankingArrayTop.length >= 5 ? rankingArrayTop.length : 5;
            let idBottom = rankingArrayBottom.length >= 10 ? rankingArrayBottom.length : 10;
            let ID = 0;
            let initialYouScore = _you.score;
            let score = topScoreFriends > _you.score ? topScoreFriends : _you.score;
            let firstNextFriend = true;

            let rankingOffset = parseInt(tools.range(30, 100));

            for (let k = idTop; k >= 0; k--) {
                element = rankingArrayTop[k] ? rankingArrayTop[k] : AssetsManager.players[k];

                if (element) {
                    element.color = element.color ? element.color : "#40cbe4";
                    if (!element.isFriend) {
                        score += Math.random() * (score * .2);
                        element.score = score;
                        element.rank = parseInt(_you.rank / (score / _you.score));
                        tools.insert(rankingArray, 0, element);
                    } else {

                        if (!element.isRealScore) {
                            element.rank = _you.rank - k - rankingOffset;
                            element.rank = tools.switchChars(element.rank, "?");
                        } else {
                            element.rank = parseInt(_you.rank / (element.score / _you.score));
                        }
                        score = element.score;
                        rankingArray.push(element);
                    }
                    AssetsManager.players.splice(k, 1);
                    ID++;
                }
            }


            // this element is alwas over "You" element
            rankingArray[0].id = "added1"
            rankingArray.push(rankingArray[0]);
            // rankingArray[0].score = initialYouScore + Math.random() * (_you.score * .2);
            score += Math.random() * (score * .2);
            rankingArray[0].score = score;
            rankingArray[0].rank = _you.rank - 1;
            rankingArray.splice(0, 1);



            rankingArray.push(_you);
            ID++;
            score = _you.score;

            // this element is alwas after "You" element
            rankingArray[0].id = "added2"
            rankingArray.push(rankingArray[0]);
            rankingArray[0].score = initialYouScore - Math.random() * (_you.score * .2);
            rankingArray[0].rank = _you.rank + 1;
            score = rankingArray[0].score;
            rankingArray.splice(0, 1);



            for (let l = 0; l < idBottom; l++) {
                element = rankingArrayBottom[l] ? rankingArrayBottom[l] : AssetsManager.players[l];
                if (element) {
                    element.color = element.color ? element.color : "#72bbf1";
                    if (element.isFriend) {
                        tools.insert(rankingArray, ID, element);
                        if (firstNextFriend) {
                            score = element.score;
                            element.rank = parseInt(_you.rank * (_you.score / element.score));
                            firstNextFriend = false;
                        }
                        if (!element.isRealScore) {
                            element.rank = parseInt(_you.rank * (_you.score / element.score));
                            element.rank = tools.switchChars(element.rank, "?");
                        } else {
                            element.rank = parseInt(_you.rank * (_you.score / element.score));
                        }
                    } else {
                        score -= Math.random() * (score * .2);
                        (element.id != "added1" && element.id != "added1") && (element.score = score);
                        element.rank = parseInt(_you.rank * (_you.score / score));
                        rankingArray.push(element);
                    }

                    AssetsManager.players.splice(l, 1);
                }
            }

            console.log("rankingArrayTop >>>>> ", rankingArrayTop);
            console.log("rankingArrayBottom >>>>> ", rankingArrayBottom);
            console.log("rankingArray >>>>> ", rankingArray);


            // correct bot ranking


            let botRank = _you.rank;
            let botScore = _you.score;

            if (config.friends.length > 0) {

                for (let i = 0; i < rankingArray.length; i++) {

                    if (rankingArray[i].name == "You" || rankingArray[i].isFriend) {
                        botRank = parseInt(rankingArray[i].rank) + (!rankingArray[i].isRealScore ? parseInt(tools.range(10, 50)) : 0);
                    }


                    if (botRank && !rankingArray[i].isFriend) {
                        rankingArray[i].rank = ++botRank;
                    }


                }

                botRank = null;

                for (let i = rankingArray.length - 1; i >= 0; i--) {

                    if (rankingArray[i].name == "You" || rankingArray[i].isFriend) {
                        botRank = parseInt(rankingArray[i].rank) - (rankingArray[i].isRealScore ? 0 : parseInt(tools.range(10, 50)));
                    }


                    if (botRank && !rankingArray[i].isFriend && rankingArray[i].name != "You") {

                        if (rankingArray[i].id == "added1") {
                            rankingArray[i].rank = _you.rank - 1;
                            rankingArray[i].score = _you.score + tools.range(2, 8);
                        } else if (rankingArray[i].id == "added2") {
                            rankingArray[i].rank = _you.rank + 1;
                        } else {
                            rankingArray[i].rank = --botRank;
                        }

                    }

                }

            } else {

                for (let i = 0; i < rankingArray.length; i++) {

                    if (rankingArray[i].name == "You") {
                        botRank = parseInt(rankingArray[i].rank);
                    }

                    if (botRank) {
                        rankingArray[i].rank = ++botRank;
                        botScore -= Math.random() * (score * .2);
                        rankingArray[i].name != "You" && (rankingArray[i].score = botScore);
                    }

                }

                botRank = null;
                botScore = _you.score;

                for (let i = rankingArray.length - 1; i >= 0; i--) {

                    if (rankingArray[i].name == "You") {
                        botRank = parseInt(rankingArray[i].rank);
                    }

                    if (botRank) {
                        rankingArray[i].rank = botRank--;
                        botScore += Math.random() * (score * .2);
                        rankingArray[i].name != "You" && (rankingArray[i].score = botScore);
                    }

                }

            }

            //








            let nbmax = rankingArray.length >= 10 ? rankingArray.length : 10;
            let inter;

            for (let i = 0; i < nbmax; i++) {

                element = rankingArray[i] ? rankingArray[i] : AssetsManager.players[i];

                // console.log(element.rank, element.score, element.name, element.color);

                let btn = new ChallengerBtn(
                    element.id,
                    element.rank,
                    element.name,
                    element.img || element.imguri,
                    element.color,
                    parseInt(element.score),
                    element.invite
                );

                btn.on("invite", () => {

                    console.log("invite (play with)");
                    this.closePopin();
                    config.inviteFriend = true;

                });

                btn.scale.set(.9);

                if (element.id == "added1") {

                    if (rankingArray[i - 1] && rankingArray[i - 1].isFriend) {
                        inter = new Sprite(AssetsManager.texturesPixi.basicInter);
                        inter.anchor.x = .5;
                        inter.tint = 0x72bbf1;
                        inter.scale.set(.5, .2);
                        inter.y = pos;
                        pos += inter.height + 5;
                        this.container.addChild(inter);
                    }

                    btn.y = pos;
                    pos += btn.height + 10;
                    this.container.addChild(btn);



                } else if (element.id == "added2") {

                    btn.y = pos;
                    pos += btn.height + 10;
                    this.container.addChild(btn);

                    if (rankingArray[i + 1] && rankingArray[i + 1].isFriend) {
                        inter = new Sprite(AssetsManager.texturesPixi.basicInter);
                        inter.anchor.x = .5;
                        inter.tint = 0x72bbf1;
                        inter.scale.set(.5, .2);
                        inter.y = pos;
                        pos += inter.height + 5;
                        this.container.addChild(inter);
                    }


                } else {


                    btn.y = pos;
                    pos += btn.height + 10;
                    this.container.addChild(btn);

                }


                if (element.name == "You") {
                    this.playerPosY = pos - (btn.height + 10) * 5 + 52;
                    this.youElement = btn;
                }

            }


        }


        this.scroll.contentY = -2000;

        gsap.to(this.scroll, {
            delay: .5, duration: 1.5, contentY: -this.playerPosY, ease: "power4.out", onStart: () => {
                this.scrollAccess = true;
            },
            onComplete: () => {

                if (GameManager.H5SDK.getPlatform().isFacebook()) {
                    this.inviteBtn.visible = true;
                    this.inviteBtn.scale.set(0);
                    gsap.to(this.inviteBtn.scale, { duration: .5, x: .8, y: .8, ease: "back.out(2)" });
                }


                this.playBtn.visible = true;
                this.playBtn.scale.set(0);
                gsap.to(this.playBtn.scale, { duration: .5, x: .8, y: .8, ease: "back.out(2)" });
            }
        });

        this.youElement.parent.addChild(this.youElement);
        gsap.to(this.youElement.scale, { delay: 1.6, duration: .3, x: 1.1, y: 1.1, ease: "none" });
        gsap.to(this.youElement.scale, { delay: 1.9, duration: 1, x: .95, y: .95, ease: "back.out(2)" });
        gsap.to(this.youElement, { delay: 1.9, duration: 1, y: this.youElement.y - 3, ease: "back.out(2)" });

    }


    set bestScoreValue(value) {

        this.bestScoreText.text = value;

    }



    set score(value) {

        this.scoreText.text = parseInt(value);

    }


    get score() {

        return this.scoreText.text;

    }


    resize() {

        console.log("resize")
        this.height = window.innerHeight;
        this.scale.x = this.scale.y;

        this.x = window.innerWidth / 2;
        this.y = window.innerHeight / 2;

    }


    update() {

        this.scrollAccess && this.scroll && this.scroll.update();
    }




}